/*
 * Click-to-enlarge lightbox for the wrpg-software-presentation image grid
 * (Map Expand / Infinite Asset Customizer sections). Reuses Dawn's own
 * <modal-dialog> custom element (see global.js) for open/close, Escape and
 * backdrop-click handling - this script only tracks which image is showing
 * inside a given dialog and swaps the <img src> on open/prev/next.
 *
 * Preloading: all full-res images are preloaded the first time a dialog is
 * opened so that prev/next navigation responds instantly instead of waiting
 * 1-2 s for each ~1600px image to arrive from the CDN.
 */
(() => {
  function getImages(dialog) {
    return (dialog.dataset.images || '').split('|').filter(Boolean);
  }

  function preloadImages(dialog) {
    if (dialog.dataset.preloaded) return;
    dialog.dataset.preloaded = '1';
    getImages(dialog).forEach((url) => {
      const p = new Image();
      p.src = url;
    });
  }

  function showImageAt(dialog, index) {
    const images = getImages(dialog);
    if (!images.length) return;
    const wrapped = ((index % images.length) + images.length) % images.length;
    dialog.dataset.currentIndex = String(wrapped);
    const img = dialog.querySelector('[data-wrpg-swp-lightbox-image]');
    if (img) img.src = images[wrapped];
  }

  document.addEventListener('click', (event) => {
    const opener = event.target.closest('[data-wrpg-swp-lightbox-open]');
    if (opener) {
      const dialog = document.getElementById(opener.getAttribute('data-wrpg-swp-lightbox-open'));
      if (!dialog) return;
      preloadImages(dialog);
      showImageAt(dialog, Number(opener.getAttribute('data-index') || 0));
      dialog.show(opener);
      return;
    }

    const prevButton = event.target.closest('[data-wrpg-swp-lightbox-prev]');
    const nextButton = event.target.closest('[data-wrpg-swp-lightbox-next]');
    if (!prevButton && !nextButton) return;

    const dialog = (prevButton || nextButton).closest('.wrpg-swp-lightbox');
    if (!dialog) return;
    const current = Number(dialog.dataset.currentIndex || 0);
    showImageAt(dialog, prevButton ? current - 1 : current + 1);
  });
})();
